import React from 'react';
import PropTypes from 'prop-types';
import Bubbles from '@/components/Bubbles';
import Button from '@/components/Button';
import TypewriterQuotes from '@/components/TypewriterQuotes';
import Slider from '@/components/Slider';
import classnames from 'classnames';
import { ViewportContext } from '../../ViewportContext';

import './style.css';

function CreateStory({ showSlider, visible, beaconIndex, onButtonFocus }) {
  return (
    <div
      data-index={beaconIndex}
      className={classnames('section', 'create', {
        'section--visible': visible,
      })}
    >
      <div
        /* BEACON */
        data-index={beaconIndex}
        data-threshold={showSlider ? 0.5 : 0.85}
        className="beacon"
      />

      <div className={classnames('sticky-content-wrapper')}>
        <h1 className="fade-in section__header">Create a beautiful story</h1>
        <p className="fade-in td1 section__text">
          We’ll guide you through the steps to create a lifeline for a loved
          one, so your memories of them may live on.
        </p>

        {showSlider ? (
          <CreateStorySlider />
        ) : (
          <div className="row" style={{ width: '100%', padding: 0 }}>
            <CreateStoryActions />
          </div>
        )}

        <div className="buttons-wrapper fade-in td5">
          <Button
            size="large"
            variant="primary"
            to="/add-lifeline"
            onFocus={() => {
              onButtonFocus(beaconIndex);
            }}
          >
            Start creating a lifeline
          </Button>
        </div>
      </div>

      <div
        /* BEACON */
        data-index={beaconIndex}
        className="beacon beacon--bottom"
      />
    </div>
  );
}

CreateStory.propTypes = {
  showSlider: PropTypes.bool.isRequired,
  visible: PropTypes.bool.isRequired,
  beaconIndex: PropTypes.number.isRequired,
};

function CreateStorySlider() {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const { isMobile } = React.useContext(ViewportContext);

  return (
    <Slider
      className="fade-in"
      autoplay={4000}
      items={[
        <ActionUpload center />,
        <ActionPlaces center />,
        <ActionHobbies isMobile={isMobile} center />,
        <ActionShare center />,
      ]}
    />
  );
}

function CreateStoryActions() {
  return (
    <>
      <ActionUpload />
      <ActionPlaces />
      <ActionHobbies />
      <ActionShare />
    </>
  );
}

function ActionUpload({ center = false }) {
  return (
    <div
      className={classnames('td1', {
        'flex-center': center,
        col: !center,
        'fade-in': !center,
      })}
    >
      <div className="hp-upload-photos-circle" />
      <h3 className="hp-circle-label">Upload photos</h3>
    </div>
  );
}

function ActionPlaces({ center = false }) {
  return (
    <div
      className={classnames('td2', {
        'flex-center': center,
        col: !center,
        'fade-in': !center,
      })}
    >
      <div className="hp-map-circle">
        <div className="hp-map-label">
          San Francisco
          <span className="hp-map-label__description">Mom's house</span>
        </div>
      </div>

      <h3 className="hp-circle-label">Add special places</h3>
    </div>
  );
}

function ActionHobbies({ center = false, isMobile }) {
  return (
    <div
      className={classnames('td3', {
        'flex-center': center,
        col: !center,
        'fade-in': !center,
      })}
    >
      <Bubbles size={isMobile ? 130 : 200} />
      <h3 className="hp-circle-label">Add passions and hobbies</h3>
    </div>
  );
}

function ActionShare({ center = false }) {
  return (
    <div
      className={classnames('td1 quotes', {
        'flex-center': center,
        col: !center,
        'fade-in': !center,
      })}
    >
      <TypewriterQuotes
        dataText={[
          'We got married in 1956 and barely spent a day apart over 55 happy years...',
          'My mom was the most beautiful, thoughtful person and will be so missed...',
          "He was thoughtful and kind. That's the Steve I knew...",
        ]}
      />
      <h3 className="hp-circle-label">Share tributes</h3>
    </div>
  );
}

export default CreateStory;
